<template>
  <TheNav />
  <main>
    <router-view />
  </main>
  <TheFooter />
  <WhatsAppButton />
</template>

<script>
import TheNav from "@/components/TheNav.vue";
import TheFooter from "@/components/TheFooter.vue";
import WhatsAppButton from "@/components/WhatsAppButton.vue";

export default {
  name: "App",
  components: { TheNav, TheFooter, WhatsAppButton },
  watch: {
    // Re-run scroll reveals whenever the route (and its content) changes
    $route() {
      this.$nextTick(() => setTimeout(this.observeReveals, 60));
    },
  },
  mounted() {
    this._io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            this._io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.14 }
    );
    this.$nextTick(this.observeReveals);
  },
  unmounted() {
    if (this._io) this._io.disconnect();
  },
  methods: {
    observeReveals() {
      document.querySelectorAll(".reveal:not(.in)").forEach((el, i) => {
        el.style.transitionDelay = (i % 3) * 0.08 + "s";
        this._io.observe(el);
      });
    },
  },
};
</script>
